/* eslint-disable max-len, no-underscore-dangle */
import React, { useEffect, useRef } from 'react'
import PropTypes from 'prop-types'
import mapboxgl from 'mapbox-gl'
import 'mapbox-gl/dist/mapbox-gl.css'
import MapboxGeocoder from '@mapbox/mapbox-gl-geocoder'

import '@mapbox/mapbox-gl-geocoder/dist/mapbox-gl-geocoder.css'

import styled from 'styled-components'
import { hasWindow } from 'util/dom'
import { getCenterAndZoom } from './util'

import { siteMetadata } from '../../../gatsby-config'

// This wrapper must be positioned relative for the map to be able to lay itself out properly
const Wrapper = styled.div`
  width: ${({ width }) => width};
  height: ${({ height }) => height};
  position: relative;
  flex: 1 0 auto;
`

const Map = () => {
  const { mapboxToken } = siteMetadata
  const mapNode = useRef(null)
  const mapRef = useRef(null)

  useEffect(() => {
    mapboxgl.accessToken = mapboxToken

    const map = new mapboxgl.Map({
      container: mapNode.current,
      style: 'mapbox://styles/phatdood9/ckbpgfu2a0ls51iqfcjtu59d9',
      center: [4.957528, 47.171145],
      zoom: 11
    });
    mapRef.current = map
    window.map = map // for easier debugging and querying via console

    map.addControl(new mapboxgl.ScaleControl({
      maxWidth: 80,
      unit: 'metric'
    }), 'bottom-right');

    map.addControl(new mapboxgl.NavigationControl(), 'top-left');

    map.addControl(new mapboxgl.GeolocateControl({
      positionOptions: {
        enableHighAccuracy: true
      },
      trackUserLocation: true
    }), 'top-left');

    map.addControl(new mapboxgl.FullscreenControl(), 'top-left');

    map.addControl(new MapboxGeocoder({
      accessToken: mapboxgl.accessToken,
      mapboxgl: mapboxgl
    }), 'top-right');

    // when this component is destroyed, remove the map
    return () => {
      map.remove()
    }
  }, [])

  if (!mapboxToken) {
    console.error('Error, no mapbox token')
  }

  if (!hasWindow) {
    return null
  }

  return (
    <Wrapper width={'100%'} height={'100vh'}>
      <div ref={mapNode} style={{ width: '100%', height: '100%' }} />
    </Wrapper>
  )
}

Map.propTypes = {
}

Map.defaultProps = {
}

export default Map

